'use strict';

loadScript('/frontend-home/setup.js/ads.js?', function() {
    var regex = new RegExp('[\\?&]adBlockerEnabled=([^&#]*)');
    var results = regex.exec(location.search);
    var adBlockerEnabled = null === results ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));

    var adBlockCheckId = document.getElementById('ad-block-check-id');
    if (adBlockerEnabled || !adBlockCheckId) {
        hideAdSpace();
    }
});

function hideAdSpace() {
    var elementsToHide = document.getElementsByClassName('hide_if_ad_blocker');
    var elementsLength = elementsToHide.length;
    if (0 < elementsLength) {
        for (var i = 0; i < elementsLength; i++) {
            elementsToHide[i].style.display = 'none';
        }
    }
}

function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) { // IE
        script.onreadystatechange = function() {
            if ('loaded' === script.readyState || 'complete' === script.readyState) {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else { // Others
        script.onload = function() {
            callback();
        };
    }
    script.onerror = function() {
        callback();
    };

    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}
